import request from '@/utils/request'

/**
 * 管理员登录
 */
export function login(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data
  })
}

/**
 * 获取管理员信息
 */
export function getAdminInfo() {
  return request({
    url: '/admin/profile',
    method: 'get'
  })
}

/**
 * 管理员登出
 */
export function logout() {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  })
}

/**
 * 修改密码
 */
export function updatePassword(data) {
  return request({
    url: '/admin/auth/password',
    method: 'put',
    data
  })
}